import { ComponentProps } from 'react';

import Typography from '@mui/material/Typography';
import clsx from 'clsx';

import { Link as NextIntlLink } from '@/i18n/navigation';

import styles from './Link.module.scss';

const isExternalLink = (href: string): boolean =>
  href.startsWith('mailto:') || href.startsWith('tel:') || href.startsWith('http');

export interface LinkProps extends Omit<ComponentProps<typeof NextIntlLink>, 'children' | 'href'> {
  text: string;
  href: string;
  className?: string;
  target?: string;
  ariaLabel?: string;
}

const Link = ({ href, text, className, target, ariaLabel, ...props }: LinkProps) => {
  const content = (
    <Typography variant="body1" className={styles.text}>
      {text}
    </Typography>
  );

  if (isExternalLink(href)) {
    return (
      <a
        href={href}
        target={target}
        rel="nofollow noopener noreferrer"
        aria-label={ariaLabel}
        className={clsx(styles.container, className)}
      >
        {content}
      </a>
    );
  }

  return (
    <NextIntlLink
      href={href as '/'}
      target={target}
      aria-label={ariaLabel}
      className={clsx(styles.container, className)}
      {...props}
    >
      {content}
    </NextIntlLink>
  );
};

export default Link;
